<div class="bg-white p-3">
    <h1>Tillfällig driftstörning</h1>
    <p>
        Försök igen senare eller kontakta support om problemet kvarstår.
    </p>
</div>